import React, {useEffect, useState} from "react";
import { useHistory } from "react-router-dom";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// core components
import Button from "components/CustomButtons/Button.js";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import { TextInput } from 'Ficha/components/TextInput'
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import ApfelLink from 'Ficha/pdf/apfelLink'
import EvalTable from 'Ficha/components/evaluations/EvalTable'
import { atualizarApfel } from 'firebase/firestoreData'

const styles = {
  cardCategoryWhite: {
    color: "rgba(255,255,255,.62)",
    margin: "0",
    fontSize: "12px",
    textAlign: "justify",
    marginTop: "0",
    marginBottom: "0"
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none"
  },
  field:{
    margin: '10px auto',
  },
  tableBox:{
    padding: 10,
  },
  formControl:{
    margin: 20,
  },
  miniTable:{
    maxWidth: 360,
    margin: '0 auto'
  },
  miniTableRow:{
    height: 42,
  },
  deleteButton:{
    margin: 20,
    border: '1px solid blue',
    color: 'blue'
  },
  heading:{
    marginLeft: 10,
  },
  buttons:{
    display: 'flex',
    justifyContent: 'space-evenly',
    marginTop: 30,
  },
  btn:{
    width: 80,
  },
  table:{
    width: '90%',
    margin: '30px auto'
  },
  texts: {
    margin: '0 auto',
    backgroundColor: 'rgb(240, 240, 240)',
    borderRadius: 8,
    maxWidth: '600px',
    padding: 8,
    paddingLeft: 15,
    textAlign: 'justify',
    boxShadow: '2px 2px 7px black'
  }
};

const useStyles = makeStyles(styles);

export default function Apfel(props) {
  const classes = useStyles();
  const ficha  = props.location.state
  const history = useHistory();
  const [showBtn, setShowBtn] = useState(false)
  const [riskSum, setRiskSum] = useState(0)
  const [riskText, setRiskText] = useState("")
  const [riskArray, setRiskArray] = useState([0, 0, 0, 0])

  useEffect(() => {
  const timer = setTimeout(() => {
    setShowBtn(true)
  }, 1000);
  return () => clearTimeout(timer);
}, []);

  useEffect(() => {
    if (ficha.apfel){
      setRiskArray(ficha.apfel)
      updateRisk(ficha.apfel)
    } else {
      setRiskArray([ficha.sexo === "Fem"? 1:0, 0, ficha.tabagismo ? 0:1, 0])
      updateRisk([ficha.sexo === "Fem"? 1:0, 0, ficha.tabagismo ? 0:1, 0])
    }
  }, [ficha.apfel, ficha.sexo, ficha.tabagismo]);

  useEffect(()=>{
    let text = ""
    if (riskSum === 0) {
        text = <p>Não foi identificado nenhum fator de risco de Apfel para NVPO<br/>
        A incidência de NVPO (sem profilaxia) é de aproximadamente <b>10%</b></p>
      }
    if (riskSum === 1) {
      text = <p>Foi identificado <b>1 fator de risco</b> de Apfel.<br/>
      A incidência de NVPO (sem profilaxia) é de aproximadamente <b>20%</b><br/>
       => Está indicado o uso de <b>2 agentes</b> anti-eméticos</p>
      }
    if (riskSum === 2) {
        text = <p>Foram identificados <b>2 fatores de risco</b> de Apfel.<br/>
        A incidência de NVPO (sem profilaxia) é de aproximadamente <b>40%</b><br/>
         => Está indicado o uso de <b>2 agentes</b> anti-eméticos</p>
      }
    if (riskSum === 3) {
      text = <p>Foram identificados <b>3 fatores de risco</b> de Apfel.<br/>
      A incidência de NVPO (sem profilaxia) é de aproximadamente <b>60%</b><br/>
       => Está indicado o uso de <b>3 ou 4 agentes</b> anti-eméticos</p>
    }
    if (riskSum === 4) {
        text = <p>Foram identificados <b>4 fatores de risco</b> de Apfel.<br/>
        A incidência de NVPO (sem profilaxia) é de aproximadamente <b>80%</b><br/>
         => Está indicado o uso de <b>3 ou 4 agentes</b> anti-eméticos</p>
    }
    setRiskText(text)
  },[riskSum])

  let genText = <p><u>RECOMENDAÇÕES GERAIS PARA REDUZIR RISCO DE NVPO:</u><br/>
  - Evitar anestesia geral, quando possível preferir anestesia regional. (A1)<br/>
  - Usar propofol para indução e manutenção anestésica. (A1)<br/>
  - Evitar óxido nitroso em cirurgias com duração maior que 1 hora (A1)<br/>
  - Evitar anestésicos inalatórios (A2)<br/>
  - Minimizar uso de opióides (A1)<br/>
  - Hidratar adequadamente (A1)<br/>
  - Usar sugammadex em vez de neostigmina na reversão do BNM (A1)</p>

  function updateRisk(riskArray) {
    setRiskArray(riskArray)
  }

  function calcRisk(riskArray) {
    let sum = 0
    for (let i = 0; i < riskArray.length; i++){
      sum = sum + riskArray[i]
    }
    setRiskSum(sum)
  }

  function saveRiskToDB() {
    atualizarApfel(ficha.id, riskArray)
  }

  return (
    <div>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <Card>
            <CardHeader color="primary">
              <h4 className={classes.cardTitleWhite}>
                Escore de APFEL para Risco de náusea e vômito pós-operatório (NVPO)
              </h4>
              <p className={classes.cardCategoryWhite}>
                Todas as informações têm caráter apenas informativo.
                As condutas médicas devem ser decididas pelo médico assistente
                junto com o paciente, respeitando os quatro princípios bioéticos
                fundamentais: autonomia, beneficência, não-maleficência e justiça.
              </p>
              <p className={classes.cardCategoryWhite}>
              Fontes:
              - Apfel, Evidence-based analysis of risk factors for postoperative nausea and vomiting. Br J Anaesth. 2012.
              - Gan, Fourth Consensus Guidelines for the Management of Postoperative Nausea and Vomiting, Anesthesia & Analgesia, 2020
              </p>
            </CardHeader>
            <CardBody>
            <form>
              <GridContainer>
                <GridItem xs={12} sm={12} md={12}>
                  <TextInput
                    className={classes.field}
                    label="Nome Completo"
                    name="nomeCompleto"
                    disabled
                    value={ficha.nome}
                  />
                </GridItem>
              </GridContainer>
              <GridContainer>
                <GridItem xs={12} sm={12} md={12}>
                  <TextInput
                    className={classes.field}
                    label="Procedimento(s)"
                    name="procedimento"
                    multiline
                    disabled
                    value={ficha.procedimentos}
                  />
                </GridItem>
                <div className={classes.table}>
                  <EvalTable onCalcRisk={calcRisk}
                             onUpdateRisk={updateRisk}
                             rows={[['Sexo Feminino?', 1],
                                   ['História de NVPO / Cinetose?', 1],
                                   ['Não Fumante?', 1],
                                   ['Opióides no pós-operatório?', 1]]}
                              initialValues={riskArray}/>
                </div>
              </GridContainer>
              </form>
              <div className={classes.texts}>
              {riskText}
              {genText}
              </div>
              <div className={classes.buttons}>
              { showBtn && <div>
                <ApfelLink ficha={ficha}
                           risk={{risk: riskSum}}
                           link={<Button className={classes.btn} onClick={saveRiskToDB} color="primary">IMPRIMIR</Button>}
                />
              </div>
              }
              <Button className={classes.btn} onClick={()=>{saveRiskToDB(); history.goBack()}} color="primary">VOLTAR</Button>
              </div>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    </div>
  );
}
